import Header from '@components/Header';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import NoticeContent from './components/NoticeContent';
import NoticeHeader from './components/NoticeHeader';
import useNotice from './hooks/useNotice';

interface Params {
    noticeId: string;
}

const NoticeActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { noticeId } = params;
  const notice = useNotice(noticeId);
  return (
      <AppScreen>
          <Header title='공지사항' />
          {notice ? (
              <Fragment>
                  <NoticeHeader title={notice.title}
                                startAt={notice.startAt}
                                endAt={notice.endAt} />
                  <NoticeContent content={notice.content}/>
              </Fragment>
          ) : (<Loading/>)}
      </AppScreen>
  );
};

export default NoticeActivity;
